<template>
  <div id="idc-sidebar" class="collapse-menu">
    <el-menu :collapse="collapse ? isCollapse : false"
             class="border-0 el-menu-vertical menu-top"
             background-color="#001529"
             text-color="#fff">
      <el-menu-item class="mb-1 brand-logo p"
                    @click="gotoPage('dashboard.index')">
        <img src="@/assets/images/ilogo.png" class="mt-0-8"/>
      </el-menu-item>
      <el-menu-item class="idc-item-menu"
                    :class="{'active': currentPage === menu.icon}"
                    v-for="menu in topMenuSidebar" :key="menu.value"
                    v-if="(menu.icon !== 'agency' || (menu.icon === 'agency' && userInfo.is_agency))"
                    @click="gotoPage(menu.value)">
        <i class="idc-icons" :class="'icon-' + menu.icon + '-white'"></i>
        <span v-if="menu.icon === 'plan'">{{$t('sidebarMenu.plan')}}</span>
        <span v-else-if="menu.icon === 'agency'">{{$t('agency.title')}}</span>
        <span v-else>{{menu.title}}</span>
      </el-menu-item>
    </el-menu>
    <el-menu :collapse="collapse ? isCollapse : false"
             class=" border-0 pb-1 el-menu-vertical menu-bottom"
             background-color="#001529"
             text-color="#fff">
      <el-menu-item class="idc-item-menu"
                    :class="{'active': currentPage === menu.icon}"
                    v-for="menu in bottomMenuSidebar" :key="menu.value"
                    @click="gotoPage(menu.value)">
        <i class="idc-icons" :class="'icon-' + menu.icon + '-white'"></i>
        <span v-if="menu.icon === 'account'">{{$t('accountMenuTxt')}}</span>
        <span v-if="menu.icon === 'billing'">{{$t('billingMenuTxt')}}</span>
      </el-menu-item>
      <el-menu-item index="4" class="idc-item-menu"
                    @click="handleLogout()">
        <i class="idc-icons icon-logout-white"></i>
        <span>{{$t('signOutMenuTxt')}}</span>
      </el-menu-item>
    </el-menu>
    <div class="close-sidebar" @click="closeSidebar()">
      <i class="el-icon-close"></i>
    </div>
  </div>
</template>
<script>
  import authServices from '@/services/auth'
  import { mapGetters } from 'vuex'

  export default {
    name: 'sidebar',
    props: ['currentPage', 'isHasNotify', 'isCollapse'],
    data () {
      return {
        activeMenu: '',
        topMenuSidebar: [
          {title: 'Dashboard', value: 'dashboard.index', icon: 'dashboard'},
          {title: this.$t('sidebarMenu.plan'), value: 'cloud-server.plans', icon: 'plan'},
          {title: 'Cloud Server', value: 'cloud-server.index', icon: 'cloud-server'},
          {title: 'Volume', value: 'volume.index', icon: 'volume'},
          {title: 'Snapshot', value: 'snapshot.index', icon: 'snapshot'},
          {title: 'SSH Key', value: 'ssh-keys.index', icon: 'ssh-keys'},
          {title: 'Ticket', value: 'ticket.index', icon: 'ticket'},
          {title: this.$t('agency.title'), value: 'agency.index', icon: 'agency'}
        ],
        bottomMenuSidebar: [
          {title: this.$t('sidebarMenu.account'), value: 'account.index', icon: 'account'},
          {title: this.$t('sidebarMenu.billing'), value: 'billing.index', icon: 'billing'}
        ],
        collapse: true
      }
    },
    computed: {
      ...mapGetters([
        'userInfo'
      ])
    },
    watch: {
      'isHasNotify' () {
        this.checkIsHasNotify()
      },
      'isCollapse' () {
        this.checkIsHasNotify()
      }
    },
    methods: {
      checkIsHasNotify () {
        if (this.isHasNotify) {
          document.getElementsByClassName('el-menu-vertical')[0].style.height = 'calc(100vh - 180px)'
          document.getElementById('idc-sidebar').style.top = '50px'
          document.getElementById('idc-sidebar').style.height = 'calc(100vh - 50px)'
        } else {
          document.getElementsByClassName('el-menu-vertical')[0].style.height = 'calc(100vh - 165px)'
          document.getElementById('idc-sidebar').style.top = '0'
          document.getElementById('idc-sidebar').style.height = 'calc(100vh)'
        }
      },
      gotoPage (menu) {
        if ((this.$router.history.current.name !== menu)) {
          this.$router.push({name: menu})
        }
      },
      handleLogout () {
        authServices.logout()
      },
      checkWidthWindows () {
        const width = window.innerWidth
        if (width <= 767) this.collapse = false
      },
      closeSidebar () {
        document.getElementById('idc-sidebar').classList.remove('show')
      }
    },
    mounted () {
      this.checkIsHasNotify()
      this.checkWidthWindows()
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/idc/components/sidebar.vue